import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import type { IntegrationIndexStatus } from "@/hooks/useIntegrationIndexMap";

export function IntegrationIndexBadge({ status }: { status: IntegrationIndexStatus }) {
  if (status !== "indexed") return null;
  return (
    <Badge variant="secondary" className="text-xs gap-1 shrink-0">
      <CheckCircle2 className="h-3 w-3" />
      Indexed
    </Badge>
  );
}
